/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild, signal} from '@angular/core';
import * as Highcharts from 'highcharts';

import template from './exploration-table.component.html';
import {APP_SHARED} from '../app-shared';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [...APP_SHARED, TabsModule, TranslateModule],
  selector: 'adn-exploration-table',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExplorationTableComponent implements OnChanges, OnDestroy {
  @Input() exploration: any;
  @Input() param: string;
  @Input() filterParam: string;
  @Input() updateFilter: (type: string, value: any) => void;

  @ViewChild('chartContainer')
  set chartContainer(chartContainer: ElementRef<HTMLElement>) {
    this.chartContainerRef = chartContainer;
    this.renderChart();
  }

  readonly showChart = signal(false);

  private chart: Highcharts.Chart | null = null;
  private chartContainerRef: ElementRef<HTMLElement> | null = null;

  get rows(): any[] {
    return this.exploration?.[this.param] || [];
  }

  get statsChart(): any {
    return this.exploration?.[this.param]?.statsChart || null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.exploration || changes.param) {
      if (!this.statsChart) {
        this.destroyChart();
      } else if (this.showChart()) {
        this.renderChart();
      }
    }
  }

  ngOnDestroy(): void {
    this.destroyChart();
  }

  onChartTabSelected(): void {
    this.showChart.set(true);
    this.renderChart();
  }

  onTableTabSelected(): void {
    this.showChart.set(false);
  }

  addFilter(row: any): void {
    this.updateFilter?.(this.filterParam, row);
  }

  private renderChart(): void {
    if (!this.showChart() || !this.chartContainerRef?.nativeElement || !this.statsChart) {
      return;
    }

    this.destroyChart();
    this.chart = Highcharts.chart(this.chartContainerRef.nativeElement, this.statsChart);
  }

  private destroyChart(): void {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
